<template>
  <the-header></the-header>
  <welcome-component></welcome-component>
  <the-page></the-page>
  <the-footer></the-footer>
</template>

<style lang="scss" src="@/assets/styles/base.scss" />
